import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setMotorResponseOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'

export function* getMotorResponseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const motorResponse: IOptionsResponse = yield call([vitalsService, vitalsService.getMotorResponse])
    const { entity } = motorResponse
    yield put(setMotorResponseOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getMotorResponseOptions() error: ${e}`))
  }
}

export function* getMotorResponseOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getMotorResponseOptions)
}
